/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TNaturalPersonUpdateRequest,
  TNaturalPersonUpdateModel,
  IMappers,
  TNaturalPersonUpdateResponse,
  TNaturalPersonUpdateResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createNaturalPersonUpdateModel(parameters: TNaturalPersonUpdateRequest): TNaturalPersonUpdateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v1/natural-person/update/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface INaturalPersonUpdateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TNaturalPersonUpdateRequest;
}

export async function fetchNaturalPersonUpdate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: INaturalPersonUpdateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TNaturalPersonUpdateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createNaturalPersonUpdateModel(parameters),
    config,
  )) as FetchResponse<TNaturalPersonUpdateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TNaturalPersonUpdateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TNaturalPersonUpdateResponse>;
}
